import { FileText, Download } from "lucide-react";
import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";

const RESOURCES = [
  { title: "Company Profile", body: "Corporate overview, capabilities, capacity and export credentials across our Spices, Makhana and Pulses divisions — for buyer due diligence." },
  { title: "Product Catalogue", body: "Complete catalogue spanning whole & ground spices, premium Makhana (fox nuts) and Pulses & Lentils — with grades, packaging and specification highlights." },
  { title: "Packaging Guide", body: "Detailed reference of packaging formats — bulk, retail, private label — with material and shelf-life data for spices, makhana and pulses." },
  { title: "Export Guide", body: "Documentation, incoterms, payment terms and lead-time reference for international buyers of Indian spices, superfoods and pulses." },
];

export default function Resources() {
  return (
    <>
      <PageHeader
        eyebrow="Buyer Resources"
        title="The documentation buyers actually need."
        italicWord="actually"
        subtitle="Everything you need to evaluate DeepRoots Spice as your Indian supply partner — organised for procurement teams, private label buyers and quality auditors."
      />

      <section className="py-24 md:py-32 bg-brand-ivory">
        <div className="container-luxe">
          <div className="grid md:grid-cols-2 gap-6">
            {RESOURCES.map((r, i) => (
              <Reveal key={r.title} delay={i * 80}>
                <div className="group p-10 bg-brand-ivory-warm border border-brand-charcoal/10 hover:border-brand-gold transition-colors h-full flex flex-col justify-between">
                  <div>
                    <div className="w-12 h-12 border border-brand-green/50 flex items-center justify-center mb-6 text-brand-green">
                      <FileText className="w-5 h-5" />
                    </div>
                    <h3 className="font-serif text-3xl text-brand-charcoal mb-3">{r.title}</h3>
                    <p className="text-brand-charcoal/60 text-[15px] leading-relaxed">{r.body}</p>
                  </div>
                  <a href="mailto:info@deeprootsspice.com?subject=Resource%20Request%20-%20{r.title}" className="mt-8 inline-flex items-center gap-2 text-[12px] tracking-[0.22em] uppercase text-brand-green font-semibold border-t border-brand-charcoal/10 pt-4 group-hover:text-brand-gold transition-colors" data-testid={`resource-${r.title.toLowerCase().replace(/\s+/g, "-")}`}>
                    <Download className="w-3.5 h-3.5" /> Available on Request
                  </a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
